import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import GeneralRevealPill from '@/components/Editor/Form/fields/GeneralRevealPill';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartGaugeIcon = function ChartGaugeIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7946_32)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.4735 15C22.8156 13.9073 23 12.7445 23 11.5385C23 5.16595 17.8513 0 11.5 0C5.14873 0 0 5.16595 0 11.5385C0 12.7445 0.184407 13.9073 0.526473 15H22.4735Z",
        fill: "#C4C4C6"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.5 2.30762C10.8649 2.30762 10.35 2.82421 10.35 3.46146V5.76916C10.35 6.40641 10.8649 6.923 11.5 6.923C12.1352 6.923 12.65 6.40641 12.65 5.76916V3.46146C12.65 2.82421 12.1352 2.30762 11.5 2.30762Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.55 10.3845C20.1852 10.3845 20.7 10.9011 20.7 11.5384C20.7 12.1756 20.1852 12.6922 19.55 12.6922H17.25C16.6149 12.6922 16.1 12.1756 16.1 11.5384C16.1 10.9011 16.6149 10.3845 17.25 10.3845H19.55Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.90005 11.5384C6.90005 10.9011 6.38518 10.3845 5.75005 10.3845H3.45005C2.81492 10.3845 2.30005 10.9011 2.30005 11.5384C2.30005 12.1756 2.81492 12.6922 3.45005 12.6922H5.75005C6.38518 12.6922 6.90005 12.1756 6.90005 11.5384Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.379 5.01147C16.8281 4.56086 17.5563 4.56086 18.0054 5.01147C18.4545 5.46207 18.4545 6.19265 18.0054 6.64325L16.379 8.27504C15.9299 8.72564 15.2018 8.72564 14.7527 8.27504C14.3036 7.82443 14.3036 7.09386 14.7527 6.64325L16.379 5.01147Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.24762 8.27469C8.69672 7.82408 8.69672 7.09351 8.24762 6.6429L6.62127 5.01112C6.17217 4.56051 5.44403 4.56051 4.99493 5.01112C4.54582 5.46172 4.54582 6.1923 4.99493 6.6429L6.62127 8.27469C7.07037 8.72529 7.79852 8.72529 8.24762 8.27469Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7946_32",
        children: /*#__PURE__*/_jsx("rect", {
          width: "23",
          height: "15",
          fill: "white"
        })
      })
    })]
  }));
};

ChartGaugeIcon.defaultProps = {
  width: "23",
  height: "15",
  viewBox: "0 0 23 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetEditFormGaugeChartFields = _ref => {
  let {
    title,
    pillVariant,
    onChartSelect
  } = _ref;
  return /*#__PURE__*/_jsx(GeneralRevealPill, {
    title: title ?? 'Gauge Chart',
    pillVariant: pillVariant,
    leftIcon: /*#__PURE__*/_jsx(ChartGaugeIcon, {}),
    onChartSelect: onChartSelect
  });
};

export default WidgetEditFormGaugeChartFields;